// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import PipIndicator, {getDefaultState as getPipIndicatorDefaultState} from './pip-indicator';
import UseAmount, {getDefaultState as getUseAmountDefaultState} from './use-amount';
import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const ProductSearchResult = t.struct({
    baseMachineCode: t.String,
    customerSummary: CustomerSummary,
    dealer: Dealer,
    deliveryDate: t.maybe(t.Number),
    httpStatus: t.maybe(t.String),
    imageUrl: t.String,
    isNonTracked: t.Boolean,
    isSap: t.Boolean,
    model: t.String,
    pin: t.String,
    pip: t.String,
    pipIndicator: PipIndicator,
    registrationDate: t.maybe(t.Number),
    status: t.list(KeyValuePair),
    updatedDate: t.maybe(t.Number),
    useAmount: UseAmount,
    useAmountLastUpdated: t.maybe(t.Number),
    warranty: t.Boolean
}, {
    name: 'ProductSearchResult',
    strict: true
});

export const getDefaultState = () => new ProductSearchResult({
    baseMachineCode: '',
    customerSummary: getCustomerSummaryDefaultState(),
    dealer: getDealerDefaultState(),
    deliveryDate: null,
    httpStatus: '',
    imageUrl: '',
    isNonTracked: false,
    isSap: true,
    model: '',
    pin: '',
    pip: '',
    pipIndicator: getPipIndicatorDefaultState(),
    registrationDate: null,
    status: [],
    updatedDate: null,
    useAmount: getUseAmountDefaultState(),
    useAmountLastUpdated: null,
    warranty: false
});

export default ProductSearchResult;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/product-search-results.js